module.exports = __webpack_public_path__ + "static/img/banner eureka.329830e3.png";